import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	permissions: [],
};

// active account slice
export const allPermissionsSlice = createSlice({
	name: 'permissions',
	initialState,
	reducers: {
		setAllPermissions: (state, action) => {
			state.permissions = action.payload;
		},
	},
});

export const {
	setAllPermissions,
} = allPermissionsSlice.actions;

export default allPermissionsSlice.reducer;
